export type PnlRange = '1d' | '1w' | '1m' | 'all';

const RANGE_MS: Record<Exclude<PnlRange, 'all'>, number> = {
  '1d': 24 * 60 * 60 * 1000,
  '1w': 7 * 24 * 60 * 60 * 1000,
  '1m': 30 * 24 * 60 * 60 * 1000,
};

export function availablePnlRanges(
  registeredAt: string | null,
  nowMs: number = Date.now(),
): PnlRange[] {
  const registeredMs = registeredAt === null ? NaN : Date.parse(registeredAt);
  if (!Number.isFinite(registeredMs) || registeredMs > nowMs) {
    return ['1d', '1w', '1m', 'all'];
  }
  const elapsedRanges = (['1d', '1w', '1m'] as const).filter(
    (range) => nowMs - registeredMs >= RANGE_MS[range],
  );
  return [...elapsedRanges, 'all'];
}
